import { render, staticRenderFns } from "./sourceB.vue?vue&type=template&id=afbf8bec&scoped=true&"
import script from "./sourceB.vue?vue&type=script&lang=js&"
export * from "./sourceB.vue?vue&type=script&lang=js&"
import style0 from "./sourceB.vue?vue&type=style&index=0&id=afbf8bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbf8bec",
  null
  
)

export default component.exports